export const getLowerEnvironmentVariables = (env) => ({
    authServiceUrl: `https://iam.${env}.org`,
    cookieDomain: `${env}.org`,
    adminUrl: `https://admin.${env}.org/oauth2/code`,
    forgotPasswordForm: `https://admin.${env}.org/admin/0/0/login/forgot_password`,
    adminEntryUrl: `admin.${env}.org`,
    consoleUrl: `https://console.${env}.org`,
    mfaIssuer: env,
    heimdallUrl: `https://auth.${env}.org`,
});
